export default {
  showThumbnails: 'Show thumbnails',
  close: 'Close gallery',
  zoomIn: 'Zoom-in',
  source: 'Source',
}
